import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { RootState, useSelector } from 'src/store';

const selectWorkspaceLocations = createSelector(
  (state: RootState) => state.location.locations,
  (locations) =>
    locations.map((location) => ({
      _id: location._id,
      name: location.name,
      workspace: location.workspace
    }))
);

export const useWorkspaceLocations = () => {
  const locations = useSelector(selectWorkspaceLocations);

  return locations;
};
